import { useUserHasConsignorMasterUI } from 'src/hooks/useUserIsConsignorMasterUI';
import { QueryWithViewMode } from 'src/utils/eventQueryUtils';
import { EntityWithTicketsQuery } from 'src/WebApiController';

import { CatalogMetricsContextProviderProps } from './CatalogMetrics.type';
import { CatalogMetricsContextV2Provider } from './CatalogMetricsContextV2';
import { CatalogMetricsEmptyContextProvider } from './CatalogMetricsEmptyContext';

export function CatalogMetricsContextProvider<
  TMetrics extends { currency: string | null },
  TQuery extends EntityWithTicketsQuery & QueryWithViewMode,
>(props: CatalogMetricsContextProviderProps<TMetrics, TQuery>) {
  // If we need to test new Metrics vNext, we would add them here
  // For example:
  // return <CatalogMetricsContextV3Provider {...props} />;

  const isConsignorMasterView = useUserHasConsignorMasterUI();

  return isConsignorMasterView ? (
    <CatalogMetricsEmptyContextProvider {...props} />
  ) : (
    <CatalogMetricsContextV2Provider {...props} />
  );
}
